'use strict';

/**
 * @abstract
 */
ngtk.controller.Base = Class({

    $inject: ['$scope'],

    $scope: undefined,

    _timeoutRegistry: undefined,

    /**
     * @param {angular.scope} $scope
     */
    construct: function($scope) {
        for (var i = 0; i < this.$inject.length; ++i) {
            var key = this.$inject[i];
            if (key.substr(0, 1) !== '$') {
                key = '_' + key;
            }
            this[key.replace(/\./g, '')] = arguments[i];
        }
        if (!this.$scope) {
            throw new Error('this.$scope is undefined');
        }
        this.$scope.$on('$destroy', this._onScopeDestroy.bind(this));
        this.$scope.ctrlStatus = {ready: false};
        this._timeoutRegistry = [];
        var result = this._init();
        if (ngtk.tools.object.isThenable(result)) {
            result.then(this._onInitReady.bind(this)).catch(this._catchError.bind(this));
        } else {
            this._onInitReady();
        }
    },

    _onScopeDestroy: function() {
        this.$timeout && this._timeoutRegistry.forEach(this._cancelTimeout.bind(this));
    },

    _setTimeout: function(fn, ms) {
        if (!this.$timeout) {
            throw new Error('$timeout not injected');
        }
        var timeoutPromise = this.$timeout(fn, ms);
        timeoutPromise.finally(function() {
            return this._removeTimeoutPromiseFromRegistry(timeoutPromise);
        }.bind(this));
        this._timeoutRegistry.push(timeoutPromise);
        return timeoutPromise;
    },

    _cancelTimeout: function(timeoutPromise) {
        if (!this.$timeout) {
            throw new Error('$timeout not injected');
        }
        this.$timeout.cancel(this._removeTimeoutPromiseFromRegistry(timeoutPromise));
    },

    _removeTimeoutPromiseFromRegistry: function(timeoutPromise) {
        var index = this._timeoutRegistry.indexOf(timeoutPromise);
        if (!~index) {
            this._timeoutRegistry.splice(index, 1);
        }
        return timeoutPromise;
    },

    /**
     * @protected
     */
    _init: function() {
        // pass
    },

    _setLoading: function() {
        this.$scope.ctrlStatus.ready = false;
    },

    _setIsReady: function() {
        this.$scope.ctrlStatus.ready = true;
    },

    _onInitReady: function() {
        this._setIsReady();
        this._run();
    },

    _showValidationError: function(response) {
        var message = "";
        if (angular.isObject(response.errors)) {
            for (var k in response.errors) {
                //noinspection JSUnfilteredForInLoop
                message += k + ': ' + response.errors[k].join('; ') + "\n";
            }
        } else {
            message = response.error;
        }
        if (this._growl) {
            this._growl.error(message);
        } else {
            console.error(message);
        }
    },

    _catchError: function(response) {
        if (this._growl) {
            this._growl.error(response);
        } else {
            console.error(response);
        }
    },

    /**
     * @protected
     */
    _run: function() {
        // pass
    }

});
